import { remoteRoleToUserRole } from "../enums/SDKUserRole";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceSubscription {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
        this.allowedRoles = model.subscription.allowedRoles.map((role) => remoteRoleToUserRole[role]);
        this.status = model.subscription.status;
        this.builderSeatLimit = model.subscription.builderSeatLimit;
        this.builderSeats = model.subscription.builderSeats;
        this.fullSeatLimit = model.subscription.fullSeatLimit;
        this.fullSeats = model.subscription.fullSeats;
        this.product = model.subscription
            .product;
        this.planInterval = model.subscription
            .planInterval;
        this.isTrial = model.subscription.isTrial;
        this.fullSeatPriceId = model.subscription.fullSeatPriceId;
        this.builderSeatPriceId = (_a = model.subscription.builderSeatPriceId) !== null && _a !== void 0 ? _a : null;
        this.currentPeriodStart = model.subscription.currentPeriodStart
            ? new Date(model.subscription.currentPeriodStart)
            : null;
        this.currentPeriodEnd = model.subscription.currentPeriodEnd
            ? new Date(model.subscription.currentPeriodEnd)
            : null;
        this.cancelAt = model.subscription.cancelAt
            ? new Date(model.subscription.cancelAt)
            : null;
        this.stripeCustomerId = (_b = model.subscription.stripeCustomerId) !== null && _b !== void 0 ? _b : null;
        this.stripeSubscriptionId = (_c = model.subscription.stripeSubscriptionId) !== null && _c !== void 0 ? _c : null;
        // @ts-expect-error TS(2322): Type '{ last4: string | undefined; expiryMonth: st... Remove this comment to see the full error message
        this.card = model.subscription.card
            ? {
                last4: model.subscription.card.last4,
                expiryMonth: model.subscription.card.expiryMonth,
                expiryYear: model.subscription.card.expiryYear,
                brand: (_d = model.subscription.card.brand) !== null && _d !== void 0 ? _d : null,
            }
            : null;
        this.amount = model.subscription.amount;
        this.stripeProductDescription =
            (_e = model.subscription.stripeProductDescription) !== null && _e !== void 0 ? _e : null;
        this.subscriptionStatusUpdatedAt = model.subscription
            .subscriptionStatusUpdatedAt
            ? new Date(model.subscription.subscriptionStatusUpdatedAt)
            : null;
        this.legacyVersion = (_f = model.subscription.legacyVersion) !== null && _f !== void 0 ? _f : null;
        this.isPricePerCreator = (_g = model.subscription.isPricePerCreator) !== null && _g !== void 0 ? _g : false;
        this.stripeProductFeatures = (_h = model.subscription.stripeProductFeatures) !== null && _h !== void 0 ? _h : [];
        this.stripeProductAdditionalFeatures =
            (_j = model.subscription.stripeProductAdditionalFeatures) !== null && _j !== void 0 ? _j : [];
        this.featuresSummary = (_k = model.subscription.featuresSummary) !== null && _k !== void 0 ? _k : {};
        this.creditsPrices = model.creditsPrices;
        this.creditBalance = model.creditBalance
            ? {
                free: ((_l = model === null || model === void 0 ? void 0 : model.creditBalance) === null || _l === void 0 ? void 0 : _l.free)
                    ? {
                        credits: {
                            ...model.creditBalance.free.credits,
                            resetAt: model.creditBalance.free.credits.resetAt
                                ? new Date(model.creditBalance.free.credits.resetAt)
                                : null,
                        },
                        spendingLimit: {
                            ...model.creditBalance.free.spendingLimit,
                            resetAt: model.creditBalance.free.spendingLimit.resetAt
                                ? new Date(model.creditBalance.free.spendingLimit.resetAt)
                                : null,
                        },
                    }
                    : null,
                paidTopUp: (_o = (_m = model === null || model === void 0 ? void 0 : model.creditBalance) === null || _m === void 0 ? void 0 : _m.paidTopUp) !== null && _o !== void 0 ? _o : null,
                paidRecurring: ((_p = model === null || model === void 0 ? void 0 : model.creditBalance) === null || _p === void 0 ? void 0 : _p.paidRecurring)
                    ? {
                        ...model.creditBalance.paidRecurring,
                        resetAt: model.creditBalance.paidRecurring.resetAt
                            ? new Date(model.creditBalance.paidRecurring.resetAt)
                            : null,
                    }
                    : null,
            }
            : null;
        this.subscriptionUpcomingChange = model.subscriptionUpcomingChange
            ? {
                effectiveAt: new Date(model.subscriptionUpcomingChange.effectiveAt),
                fullSeatLimit: (_q = model.subscriptionUpcomingChange.fullSeatLimit) !== null && _q !== void 0 ? _q : null,
                builderSeatLimit: (_r = model.subscriptionUpcomingChange.builderSeatLimit) !== null && _r !== void 0 ? _r : null,
                additionalCredits: (_s = model.subscriptionUpcomingChange.additionalCredits) !== null && _s !== void 0 ? _s : null,
            }
            : null;
    }
    static fromTransport(model) {
        return new WorkspaceSubscription(model);
    }
}
